<template>
	<section class="Buttons">
		<OptionButton v-for="btn in validButtons" :data="btn" :key="`btn_${btn.id}`" @select="onClickButton" />
	</section>
</template>

<script>
	import OptionButton from './buttons/OptionButton';
	export default {
		components: {
			OptionButton
		},
		props: ['data'],
		data() {
			return {};
		},
		methods: {
			onClickButton(button) {
				this.$emit('select', button);
			}
		},
		computed: {
			validButtons() {
				return this.data?.filter(btn => !btn.area) ?? [];
			}
		}
	};
</script>

<style scoped lang="scss">
	.Buttons {
		display: flex;
		align-items: flex-start;
		flex-wrap: wrap;
		margin: -0.5rem;

		/deep/ .OptionButton {
			margin: 0.5rem;
		}
	}
</style>
